import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";

export const Shell = ({ children }) => (
  <div className="App" data-testid="app-shell">
    <Nav />
    <main data-testid="main-content">{children}</main>
    <Footer />
  </div>
);

export default Shell;
